import numbro from 'numbro';
import { NumberFormatType, KpiLineFormat } from '@util/enums';
function isFiniteNumber(valueToCheck) {
    return !Number.isNaN(valueToCheck) && Number.isFinite(valueToCheck);
}
export function formatNumber(value, numberFormatType) {
    var formatted = '';
    if (!value && value !== 0) {
        return formatted;
    }
    var parsedValue = Number(value);
    if (isFiniteNumber(parsedValue)) {
        if (numberFormatType === NumberFormatType.FORMATTED) {
            if (parsedValue >= 1000000 || parsedValue <= -1000000) {
                formatted = numbro(parsedValue).format({ thousandSeparated: true, totalLength: 4, average: true });
            }
            else {
                formatted = numbro(parsedValue).format({ thousandSeparated: true, mantissa: 2 });
            }
        }
        else if (numberFormatType === NumberFormatType.TWO_DECIMALS) {
            formatted = numbro(parsedValue).format({ thousandSeparated: true, mantissa: 2 });
        }
        else if (numberFormatType === NumberFormatType.WHOLE_NUMBERS) {
            formatted = numbro(parsedValue).format({ thousandSeparated: true, mantissa: 0 });
        }
        else if (numberFormatType === NumberFormatType.THOUSANDS) {
            formatted = numbro(parsedValue / 1000).format({ thousandSeparated: true, mantissa: 2 });
        }
        else if (numberFormatType === NumberFormatType.THOUSANDS_WHOLE) {
            formatted = numbro(parsedValue / 1000).format({ thousandSeparated: true, mantissa: 0 });
        }
        else if (numberFormatType === NumberFormatType.UNFORMATTED) {
            formatted = numbro(parsedValue).format({
                thousandSeparated: true,
                mantissa: 5,
                optionalMantissa: true,
                trimMantissa: true,
            });
        }
    }
    return formatted;
}
export function formatNumberKPI(value, kpiLineFormat) {
    var formatted = '';
    var parsedValue = Number(value);
    if (isFiniteNumber(parsedValue)) {
        if (kpiLineFormat === KpiLineFormat.PERCENT_2DECIMALS) {
            formatted = numbro(parsedValue / 100).format({ output: 'percent', mantissa: 2 });
        }
        else if (kpiLineFormat === KpiLineFormat.PERCENT_WHOLE) {
            formatted = numbro(parsedValue / 100).format({ output: 'percent', mantissa: 0 });
        }
        else if (kpiLineFormat === KpiLineFormat.DEFAULT) {
            formatted = numbro(parsedValue).format({ mantissa: 2 });
        }
        else {
            formatted = numbro(value).format({ thousandSeparated: true, mantissa: 2 });
        }
    }
    return formatted;
}
export function formatFloat(value) {
    if (!isNaN(value) && value) {
        return numbro(value).format({ trimMantissa: true, optionalMantissa: true, mantissa: 2 });
    }
    return value;
}
export function toFloat(value) {
    var f = value;
    if (value.replace) {
        f = value.replace(',', '.');
    }
    return Number.parseFloat(Number.parseFloat(f).toPrecision(12));
}
export function setNumbersLocale(locale) {
    numbro.setLanguage(locale);
}
